import * as React from 'react';
import { Delete } from '@wix/wix-ui-icons-common';
import { st, classes } from '../FileUpload.st.css';
import { Spinner } from '../../Spinner';
import { DATA_HOOKS } from '../dataHooks';
import { IconTooltip } from '../../IconTooltip';
const FileUploadIndicator = ({ state, onDeleteClick, deleteText, }) => {
    const [showTooltip, setShowTooltip] = React.useState(false);
    if (state === 'uploading') {
        return (React.createElement(Spinner, { "data-hook": DATA_HOOKS.spinner, className: classes.spinner }));
    }
    return (React.createElement("div", { className: st(classes.delete, {
            error: state === 'error',
        }) },
        React.createElement(IconTooltip, { "data-hook": DATA_HOOKS.delete, onMouseEnter: () => setShowTooltip(true), onMouseLeave: () => setShowTooltip(false), onClick: onDeleteClick, showTooltip: deleteText && showTooltip, message: deleteText, icon: React.createElement(Delete, null) })));
};
export default FileUploadIndicator;
//# sourceMappingURL=FileUploadIndicator.js.map